import { useTranslation } from 'react-i18next';

import { PASSWORD_HINT_KEY, PASSWORD_MIN_LENGTH } from '../utils/validation';

/**
 * The hint rendered under every password field ("Must be at least 12 characters").
 *
 * Six auth surfaces show it — join, register, reset password, external reset
 * password, user settings and the sysadmin set-password dialog — so the key and
 * its interpolated `min` live here once. The count is interpolated from
 * PASSWORD_MIN_LENGTH rather than written into each locale string, which is how
 * the retired `auth:resetPassword.passwordHint` keys ended up claiming "8" in
 * Spanish and Hebrew long after the constant became 12.
 */
export function usePasswordHint(): string {
  const { t } = useTranslation('common');
  return t(PASSWORD_HINT_KEY, { min: PASSWORD_MIN_LENGTH });
}
